import { rem } from 'polished';
import styled from 'styled-components';

import { IRatingListProps } from './Rating.types';

export const StyledList = styled.ul<IRatingListProps>`
  display: flex;
  flex-direction: row;
  margin: 0;
  padding: 0;
`;

export const StyledListItem = styled.li`
  list-style: none;

  &:not(:first-child) {
    margin-left: ${({ theme }) => rem(theme.spacings.xs)};
  }

  svg {
    display: block;
    width: ${({ theme }) => rem(theme.spacings.s)};
    height: ${({ theme }) => rem(theme.spacings.s)};
  }
`;
